module.exports = __webpack_public_path__ + "static/media/angle-double-next.d4d4ccff.svg";